import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import Higher_2020 from '../2020/Higher_2020';
import Higher_2021 from '../2021/Higher_2021';
import Higher_2022 from '../2022/Higher_2022';
import Higher_2023 from '../2023/Higher_2023';
import hsdata2022 from '../2022/Higher_Studies_data_2022'
import hsdata2023 from '../2023/Higher_Studies_data_2023';



const Higher = () => {
  return (

    <div>
    <div className='myheader'>
      <button className='merabtn'>
      <span>Higher Studies</span><i></i>
      </button>
    </div>
 

 


    <div> 
    <div className='myclass'>
            
   
            <Link exact to="/hs/2023">
                <div className='menuLink'>
                2023
                </div>
            </Link>

            <Link exact to="/hs/2022">
                <div className='menuLink'>
                    2022
                </div>               
            </Link>




    </div> 
  

  <Routes>
  
    <Route exact path="2023" element={<Higher_2023 data={hsdata2023} />} />
    <Route exact path="2022" element={<Higher_2022 data = {hsdata2022}/>} />
    <Route exact path="2021" element={<Higher_2021 />} />
    <Route exact path="2020" element={<Higher_2020 />} />
 

  </Routes>

  </div>
   

</div>
  )
}

export default Higher